import { rankingData } from '@/mocks/homepage';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">热度榜单</h2>
          <p className="text-sm text-foreground-500 mt-2">实时更新 · 全网最热爆料排行</p>
        </div>
        <div className="space-y-3">
          {rankingData.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-3 md:gap-4 bg-background-50 rounded-xl p-4 hover:bg-background-50 transition-colors cursor-pointer group"
            >
              <div className={`w-8 h-8 flex-shrink-0 flex items-center justify-center rounded-lg font-heading font-bold text-sm ${item.rank <= 3 ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-500'}`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm md:text-base font-medium text-foreground-800 group-hover:text-primary-600 transition-colors truncate">
                  {item.title}
                </p>
                <p className="text-xs text-foreground-400 mt-0.5">{item.heat}</p>
              </div>
              {item.tag && (
                <span className={`flex-shrink-0 px-2 py-0.5 ${item.tagColor} text-background-50 rounded text-xs font-medium whitespace-nowrap`}>
                  {item.tag}
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}